module.exports = {
      id: "instagram-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.bfe893b5.svg#instagram-usage",
      toString: function () {
        return this.url;
      }
    }